<template>
  <div class="im-quick-reply">
    <div class="im-quice-reply-head">
      <div class="left" @click="onBack">
        <uni-icons type="back" class="back" size="26" />
        <div class="text">返回</div>
      </div>
      <div class="btns">
        <span v-if="!isEdit" class="option" @click="isEdit = true"> 管理快捷回复 </span>
        <span v-if="isEdit" class="add" @click="onAdd">新增</span>
        <span v-if="isEdit" class="delete" @click="onDelete">删除</span>
        <!-- <span v-if="isEdit" @click="isEdit = false" class="over">完成</span> -->
      </div>
    </div>
    <div class="im-quick-reply-content">
      <quick-reply-list
        v-if="list && list.length"
        :list="list"
        :status="isEdit"
        @selected="onSelect"
        @checked="onChecked"
      />
      <div v-else class="im-quick-reply-none">暂无记录</div>
    </div>
    <!-- 新增快捷回复 -->
    <uni-popup ref="popup" class="popup-quick-reply-custom" type="dialog">
      <uni-popup-dialog
        type="info"
        mode="slot"
        class="dialog-wrap-quick-reyly"
        :showConfirmButton="true"
        :hidetitle="true"
        confirmText="保存"
        cancelText="取消"
        @confirm="onConfirm"
      >
        <template>
          <div class="form-wraps">
            <div class="head-title">新增快捷回复：</div>
            <div class="textarea-wraps">
              <textarea
                v-model="message"
                class="textarea"
                maxlength="100"
                placeholder="请输入快捷回复内容"
                :show-confirm-bar="false"
              ></textarea>
              <div v-if="showMessage" class="error-message">快捷回复内容不可为空，最多100字；</div>
            </div>
          </div>
        </template>
      </uni-popup-dialog>
    </uni-popup>
  </div>
</template>

<script>
import QuickReplyList from './quick-reply-list.vue'
import {
  saveQuickResponses,
  getQuickResponses,
  deleteQuickResponses
} from '@/views/funcPuzzle/utils/index.js'
import { mapState } from 'vuex'
export default {
  name: 'ImQuickReply',
  components: {
    QuickReplyList
  },

  data() {
    return {
      isEdit: false,
      list: [],
      isFocus: false,
      message: '',
      showMessage: false // 错误提示
    }
  },
  computed: {
    ...mapState(['doctor']),
    ...mapState('user', ['userInfos']),
    canDelete() {
      // 删除按钮是否可用
      return !!this.list.find(item => {
        return item.isActive
      })
    }
  },
  created() {
    this.initList()
  },
  methods: {
    async initList() {
      const { code, data = [] } = await getQuickResponses({
        hospitalID: this.doctor.hospitalID,
        doctorID: this.doctor.doctorID
      })
      if (code === 0) {
        data.forEach(item => {
          item.isActive = false
        })
        this.list = data || []
      }
    },
    onBack() {
      if (this.isEdit) {
        // 编辑状态点返回退出编辑状态
        this.isEdit = false
        return
      }
      this.$emit('back')
    },
    onSelect({ message = '' }) {
      this.$emit('selected', message)
    },
    onChecked({ id }) {
      // 更新选中数据
      this.list.forEach(item => {
        if (item.id === id) {
          item.isActive = true
        }
      })
    },
    onAdd() {
      this.onResetForm()
      this.$refs.popup.open()
    },

    onDelete() {
      if (!this.canDelete) {
        // 不可删除
        return
      }
      const nData = this.list.reduce(
        (res, item) => {
          if (item && !item.isActive) {
            res.res.push(item)
          } else {
            deleteQuickResponses({
              id: item.id,
              hospitalID: this.doctor.hospitalID,
              doctorID: this.doctor.doctorID
            })
            res.del.push(item) // 收集删除项
          }
          return res
        },
        { res: [], del: [] }
      )
      this.list = nData.res
      // await this.initList()
    },
    validateForm() {
      // 验证添加快捷回复
      if (!this.message) {
        this.showMessage = true
        return false
      }
      return true
    },
    async onConfirm() {
      if (!this.validateForm()) {
        return
      }
      const { code, codeDesc } = await saveQuickResponses({
        message: this.message,
        hospitalID: this.doctor.hospitalID,
        doctorID: this.doctor.doctorID
      })
      if (code !== 0) {
        Toast.fail(codeDesc || '添加失败')
        Toast({
          title: '添加失败',
          icon: 'none'
        })
        return
      }
      this.onResetForm()
      this.$refs.popup.close()
      await this.initList()
    },
    onResetForm() {
      // 重置表单
      this.message = ''
      this.showMessage = false
    }
  }
}
</script>

<style lang="scss">
.form-wraps {
  padding-top: 0.938667rem;
  flex: 1;

  .head-title {
    font-size: 0.768rem;
    line-height: 0.768rem;
    font-weight: bold;
    color: #222222;
  }
  .textarea-wraps {
    position: relative;
    padding: 0.682667rem 0 0.597333rem;
    .textarea {
      box-sizing: border-box;
      display: block;
      padding: .213333rem;
      height: 3.2rem;
      width: 100%;
      font-size: 0.64rem;
      line-height: 0.853333rem;
      resize: none;
    }

    .error-message {
      position: absolute;
      left: 0;
      bottom: 0.128rem;
      font-size: 0.426667rem;
      line-height: 0.426667rem;
      color: #ff7555;
    }
  }
}

.im-quick-reply {
  display: flex;
  flex-direction: column;
  height: 100%;

  .im-quice-reply-head {
    padding-left: 0.682667rem;
    padding-right: 0.682667rem;
    flex: 0 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .back {
      position: relative;
      left: -0.085333rem;
      top: 0.085333rem;
    }

    .left {
      display: flex;
      align-items: center;
      padding: 0.768rem 0 0.682667rem;
      font-size: 0.64rem;
      line-height: 0.64rem;
      color: #222222;

      .text {
        display: block;
        font-size: 0.64rem;
      }
    }

    .btns {
      padding: 0.768rem 0 0.768rem 0;
      font-size: 0.64rem;
      line-height: 0.64rem;

      .add,
      .option {
        padding-left: 0.768rem;
        color: #0089ff;
        font-weight: 400;
      }

      .delete {
        padding-left: 0.768rem;
        color: #ff7555;
        font-weight: 400;
      }

      .over {
        padding-left: 0.768rem;
        font-weight: 400;
      }
    }
  }

  .im-quick-reply-content {
    flex: 1;
    overflow: hidden;

    .im-quick-reply-none {
      padding: 2.133333rem 0 2.133333rem;
      text-align: center;
    }
  }
}

.popup-quick-reply-custom {
  padding: 0;
  height: 0;
}
</style>
